// Chasses de DM Sans ExtraBold, en millièmes de corps.
// Même face que les titres de Vahinn (« tu dors ? ») : preview, page de garde et PdfKit.
const FIRST_CODE = 32;
const LATIN_WIDTHS = [
	232, 315, 374, 862, 606, 913, 786, 201, 408, 408, 517, 582, 252, 579, 258, 430,
	706, 369, 578, 604, 655, 623, 635, 537, 635, 635, 260, 283, 582, 582, 582, 540,
	1050, 713, 641, 740, 709, 585, 558, 780, 717, 276, 545, 660, 562, 890, 733, 785,
	618, 785, 634, 606, 601, 687, 709, 1023, 676, 640, 581, 383, 430, 383, 682, 732,
	237, 590, 658, 610, 657, 605, 374, 600, 622, 277, 277, 586, 271, 946, 621, 612,
	658, 657, 413, 535, 437, 621, 569, 826, 578, 609, 493, 475, 276, 475, 582, 537,
	537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537,
	537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537, 537,
	232, 315, 610, 630, 563, 654, 276, 620, 342, 784, 509, 520, 582, 537, 510, 403,
	365, 582, 364, 358, 237, 628, 659, 258, 270, 241, 489, 520, 851, 886, 936, 540,
	713, 713, 713, 713, 713, 713, 948, 740, 585, 585, 585, 585, 276, 276, 276, 276,
	720, 733, 785, 785, 785, 785, 785, 582, 778, 687, 687, 687, 687, 640, 618, 716,
	590, 590, 590, 590, 590, 590, 947, 610, 605, 605, 605, 605, 271, 271, 271, 271,
	642, 621, 612, 612, 612, 612, 612, 582, 594, 621, 621, 621, 621, 609, 658, 609,
];

const PUNCTUATION_WIDTHS = {
	0x2010: 537,
	0x2011: 537,
	0x2012: 537,
	0x2013: 699,
	0x2014: 922,
	0x2015: 537,
	0x2018: 260,
	0x2019: 260,
	0x201A: 261,
	0x201C: 462,
	0x201D: 462,
	0x201E: 465,
	0x2022: 390,
	0x2026: 699,
	0x2039: 315,
	0x203A: 315,
	0x20AC: 791,
};

// Hors table (cyrillique, emoji, CJK…) : estimation large, pour couper
// trop tôt plutôt que laisser une ligne déborder.
const WIDE_CHAR_WIDTH = 1000;
const DEFAULT_CHAR_WIDTH = 600;

function charWidth(code) {
	const index = code - FIRST_CODE;
	if(index >= 0 && index < LATIN_WIDTHS.length && LATIN_WIDTHS[index]) {
		return LATIN_WIDTHS[index];
	}
	if(PUNCTUATION_WIDTHS[code]) {
		return PUNCTUATION_WIDTHS[code];
	}
	if(code >= 0x2E80) {
		return WIDE_CHAR_WIDTH;
	}
	return DEFAULT_CHAR_WIDTH;
}

// Largeur du texte en em (1 = le corps de la police).
export function measureCoverQuoteEm(text = '') {
	return Array.from(`${text || ''}`)
		.reduce((total, char) => total + charWidth(char.codePointAt(0)), 0) / 1000;
}
